import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "invest-detail" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("地产物业")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("品牌厂商")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("社区商家")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("非注册会员")
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "el-upload-list__item-actions" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("发布")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("撤回")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("返回列表")
const _hoisted_17 = ["src"]

import { Plus, UploadFilled } from "@element-plus/icons-vue";
import { defineComponent } from "vue";
import store from "@/store/index";
import { useStore } from "@/store/index";
import { ref, reactive } from "vue";
import tool from "@/utils/tool";
import router from "@/router/index";
import { ElButton, ElMessage, ElMessageBox } from "element-plus";
import type { ElForm, Action } from "element-plus";
import type {
  UploadFile,
  ElUploadProgressEvent,
  ElFile,
} from "element-plus/es/components/upload/src/upload.type";

interface activityVo {
  id: string;
  projectId: string;
  activityTagId: string;
  type: string;
  status: number;
  name: string;
  province: string;
  city: string;
  area: string;
  address: string;
  contact: string;
  mobile: string;
  startTime: string;
  endTime: string;
  allowApplyUsers: string[];
  allowApplyUser: string;
  joinQuantity: string;
  summary: string;
  request: string;
  activityImages: activityImageVo[];
  imgUrlJson: string;
}
interface activityImageVo {
  uid: number;
  imgUrl: string;
  thumbnailUrl: string;
  url: string;
}
type FormInstance = InstanceType<typeof ElForm>;

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const dialogImageUrl = ref("");
const dialogVisible = ref(false);
const isEdit = ref(true);
const checkList = ref(["1", "2", "3", "4"]);
const createOrEditFormData: activityVo = {
  id: "",
  projectId: "",
  activityTagId: "",
  type: "2",
  status: 0,
  name: "",
  province: "",
  city: "",
  area: "",
  address: "",
  startTime: "",
  endTime: "",
  contact: "",
  mobile: "",
  joinQuantity: "",
  allowApplyUsers: [],
  allowApplyUser: "",
  summary: "",
  request: "",
  activityImages: [],
  imgUrlJson: "",
};
const communityFormRef = ref<FormInstance>();
const bindData = reactive({
  createOrEditFormData: createOrEditFormData,
  projects: [],
  joinCategorys: [],
  activityTags: [],
  actionUrl: tool.url("/middle/activity/uploadActivityImg"),
  areaId: "",
});

var id = router.currentRoute.value.params.id;
if (typeof id == "string") {
  bindData.createOrEditFormData.id = id;
} else {
  var i;
  for (i = 0; i < id.length; i++) {
    bindData.createOrEditFormData.id = id[i];
  }
}

const communityRules = reactive({
  name: [{ required: true, message: "请输入活动标题", trigger: "blur" }],
  startTime: [{ required: true, message: "请输入起止时间", trigger: "change" }],
  contact: [{ required: true, message: "请输入联系人", trigger: "blur" }],
  mobile: [{ required: true, message: "请输入联系电话", trigger: "blur" }],
});

const saveEvent = (status: number,formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.validate((valid) => {
    if (valid) {
      var allowApplyUser = "";
      var allowApplyUsers = bindData.createOrEditFormData.allowApplyUsers;
      if (allowApplyUsers) {
        for (var value of allowApplyUsers) {
          if (!allowApplyUser) {
            allowApplyUser = value;
          } else {
            allowApplyUser = allowApplyUser + "," + value;
          }
        }
      }
      if (status) {
        bindData.createOrEditFormData.status = status;
      }
      var id = bindData.createOrEditFormData.id;
      if ("add" == id) {
        bindData.createOrEditFormData.id = "";
      }
      bindData.createOrEditFormData.allowApplyUser = allowApplyUser;
      bindData.createOrEditFormData.imgUrlJson = JSON.stringify(
        bindData.createOrEditFormData.activityImages
      );
      store
        .dispatch("communityModule/saveActivity", bindData.createOrEditFormData)
        .then(
          (data) => {
            bindData.createOrEditFormData.id = data.result;
            ElMessage.success(data.msg);
            isEdit.value = true;
          },
          (error) => {
            console.log(error.msg);
          }
        );
    } else {
      console.log("error submit!");
      return false;
    }
  });
};

const updateActivityStatusEvent = (status: number) => {
  var id = bindData.createOrEditFormData.id;
  if ("add" == id) {
    bindData.createOrEditFormData.id = "";
  }
  var msg = "您确定要发布吗?";
  if (status == 1) {
    var msg = "您确定要撤回吗?";
  }
  ElMessageBox.confirm(msg)
    .then(() => {
      const params = {
        id: id,
        status: status,
      };
      store.dispatch("communityModule/updateActivityStatus", params).then(
        (data) => {
          //成功
          ElMessage.success("成功.");
          activityEvent();
          activityImageEvent();
        },
        (error) => {
          ElMessageBox.alert(error.msg, "系统消息", {
            confirmButtonText: "关闭",
            callback: (action: Action) => {},
          });
        }
      );
    })
    .catch(() => {
      // catch error
    });
};

const projectEvent = () => {
  store
    .dispatch("communityModule/listProject", bindData.createOrEditFormData)
    .then(
      (data) => {
        bindData.projects = data.result;
      },
      (error) => {
        console.log(error.msg);
      }
    );
};

const joinCategoryEvent = () => {
  store
    .dispatch("communityModule/listJoinCategory", bindData.createOrEditFormData)
    .then(
      (data) => {
        bindData.joinCategorys = data.result;
      },
      (error) => {
        console.log(error.msg);
      }
    );
};

const activityEvent = () => {
  store
    .dispatch("communityModule/getActivity", bindData.createOrEditFormData)
    .then(
      (data) => {
        bindData.createOrEditFormData = data.result;
        bindAreaData(data.result.area);
        var allowApplyUser = bindData.createOrEditFormData.allowApplyUser;
        if (allowApplyUser) {
          bindData.createOrEditFormData.allowApplyUsers =
            allowApplyUser.split(",");
        }
      },
      (error) => {
        console.log(error.msg);
      }
    );
};

const activityImageEvent = () => {
  store
    .dispatch(
      "communityModule/listActivityImage",
      bindData.createOrEditFormData
    )
    .then(
      (data) => {
        //成功
        bindData.createOrEditFormData.activityImages = [];
        var index = 1;
        for (var image of data.result) {
          const imageFile: activityImageVo = {
            uid: index,
            imgUrl: image.imgUrl,
            thumbnailUrl: image.thumbnailUrl,
            url: image.thumbnailUrl,
          };
          bindData.createOrEditFormData.activityImages.push(imageFile);
        }
        index++;
      },
      (error) => {
        console.log(error.msg);
      }
    );
};

const activityTagEvent = () => {
  store.dispatch("communityModule/listActivityTag", { type: 2 }).then(
    (data) => {
      bindData.activityTags = data.result;
    },
    (error) => {
      console.log(error.msg);
    }
  );
};

joinCategoryEvent();
activityTagEvent();
projectEvent();
var lid = bindData.createOrEditFormData.id;
if (lid && lid != "add") {
  activityEvent();
  activityImageEvent();
} else {
  isEdit.value = false;
  bindData.createOrEditFormData.status = 1;
}
const toCommunityDetail = (id: string) => {
  router.push("/middleGround/community/communityList/communityDetail/" + id);
};

const toCommunityList = () => {
  router.push("/middleGround/community/communityList");
};

const handleRemove = (file: UploadFile) => {
  const activityImages = bindData.createOrEditFormData.activityImages;
  bindData.createOrEditFormData.activityImages = [];
  //成功
  for (var image of activityImages) {
    if (image.uid != file.uid) {
      bindData.createOrEditFormData.activityImages.push(image);
    }
  }
};

const handlePictureCardPreview = (file: UploadFile) => {
  dialogImageUrl.value = file.url!;
  dialogVisible.value = true;
};

const uploadSuccessEvent = (
  response: any,
  file: UploadFile,
  fileList: UploadFile[]
) => {
  const imageFile: activityImageVo = {
    uid: file.uid,
    imgUrl: response.result,
    thumbnailUrl: "",
    url: file.url!,
  };
  bindData.createOrEditFormData.activityImages.push(imageFile);
};

var chinaAreaDataOptions = ref("");
tool.getChinaAreaData(function (data) {
  chinaAreaDataOptions.value = data;
});

const selectAreaEvent = (value: any) => {
  if (value.length > 0) {
    //省
    const firstValue = value[value.length - 3];
    var province = tool.areaCodeToText.get(firstValue);
    if (province != undefined) {
      bindData.createOrEditFormData.province = province;
    }
    //市
    const secordValue = value[value.length - 2];
    var city = tool.areaCodeToText.get(secordValue);
    if (city != undefined) {
      bindData.createOrEditFormData.city = city;
    }
    //取最后一个
    const lastValue = value[value.length - 1];
    var areaName = tool.areaCodeToText.get(lastValue);
    bindData.areaId = lastValue;
    if (areaName != undefined) {
      bindData.createOrEditFormData.area = areaName;
    }
  }
};

const bindAreaData = (areaName: string) => {
  var areaValue = tool.areaTextToCode.get(areaName);
  if (areaValue != undefined) {
    bindData.areaId = areaValue;
  }
};

const handleEdit = () => {
  isEdit.value = false;
};
const handleSub = () => {
  isEdit.value = true;
};

const handleDisabledDate = (time: any) => {
  const beginDateVal = new Date(
    bindData.createOrEditFormData.startTime
  ).getTime();
  if (beginDateVal) {
    return time.getTime() < beginDateVal;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_zoom_in = _resolveComponent("zoom-in")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref_key: "communityFormRef",
      ref: communityFormRef,
      model: _unref(bindData).createOrEditFormData,
      rules: _unref(communityRules),
      "label-width": "120px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "活动名称",
          prop: "name"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(bindData).createOrEditFormData.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(bindData).createOrEditFormData.name) = $event)),
              readonly: isEdit.value,
              "input-style": [{background:(isEdit.value===true?'#f5f7fa':'')},{width:'300px'}],
              placeholder: "请输入活动名称",
              size: "default"
            }, null, 8, ["modelValue", "readonly", "input-style"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "活动类型",
          prop: "activityTagId"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _unref(bindData).createOrEditFormData.activityTagId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(bindData).createOrEditFormData.activityTagId) = $event)),
              disabled: isEdit.value,
              placeholder: "请选择"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).activityTags, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.name,
                    label: item.name,
                    value: item.id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "所属项目" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _unref(bindData).createOrEditFormData.projectId,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(bindData).createOrEditFormData.projectId) = $event)),
              disabled: isEdit.value,
              placeholder: "请选择"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).projects, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.name,
                    label: item.name,
                    value: item.id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "参与对象" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_checkbox_group, {
              modelValue: _unref(bindData).createOrEditFormData.allowApplyUsers,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(bindData).createOrEditFormData.allowApplyUsers) = $event)),
              disabled: isEdit.value
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox, { label: "1" }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_checkbox, { label: "2" }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_checkbox, { label: "3" }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_checkbox, { label: "4" }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "活动地点" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_cascader, {
              disabled: isEdit.value,
              options: _unref(chinaAreaDataOptions),
              onChange: selectAreaEvent,
              modelValue: _unref(bindData).areaId,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(bindData).areaId) = $event))
            }, {
              default: _withCtx(({ node, data }) => [
                _createElementVNode("span", null, _toDisplayString(data.label), 1),
                (!node.isLeaf)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, " (" + _toDisplayString(data.children.length) + ") ", 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["disabled", "options", "modelValue"]),
            _createVNode(_component_el_input, {
              modelValue: _unref(bindData).createOrEditFormData.address,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(bindData).createOrEditFormData.address) = $event)),
              readonly: isEdit.value,
              "input-style": [{background:(isEdit.value===true?'#f5f7fa':'')},{width:'300px'},{marginTop: '4px'}],
              placeholder: "",
              size: "default"
            }, null, 8, ["modelValue", "readonly", "input-style"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "联系人",
          prop: "contact"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(bindData).createOrEditFormData.contact,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(bindData).createOrEditFormData.contact) = $event)),
              readonly: isEdit.value,
              "input-style": [{background:(isEdit.value===true?'#f5f7fa':'')},{width:'300px'}],
              placeholder: "请输入联系人",
              size: "default"
            }, null, 8, ["modelValue", "readonly", "input-style"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "联系电话",
          prop: "mobile"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(bindData).createOrEditFormData.mobile,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(bindData).createOrEditFormData.mobile) = $event)),
              readonly: isEdit.value,
              "input-style": [{background:(isEdit.value===true?'#f5f7fa':'')},{width:'300px'}],
              placeholder: "请输入联系电话",
              size: "default"
            }, null, 8, ["modelValue", "readonly", "input-style"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "计划报名人数" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(bindData).createOrEditFormData.joinQuantity,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(bindData).createOrEditFormData.joinQuantity) = $event)),
              readonly: isEdit.value,
              "input-style": [{background:(isEdit.value===true?'#f5f7fa':'')},{width:'300px'}],
              placeholder: "",
              size: "default"
            }, null, 8, ["modelValue", "readonly", "input-style"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "图册" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_upload, {
              action: _unref(bindData).actionUrl,
              "file-list": _unref(bindData).createOrEditFormData.activityImages,
              disabled: isEdit.value,
              "on-success": uploadSuccessEvent,
              "list-type": "picture-card",
              "auto-upload": true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    (!isEdit.value)
                      ? (_openBlock(), _createBlock(_unref(Plus), { key: 0 }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              file: _withCtx(({ file }) => [
                _createElementVNode("div", null, [
                  _createElementVNode("img", {
                    class: "el-upload-list__item-thumbnail",
                    src: file.url,
                    alt: ""
                  }, null, 8, _hoisted_7),
                  _createElementVNode("span", _hoisted_8, [
                    _createElementVNode("span", {
                      class: "el-upload-list__item-preview",
                      onClick: ($event: any) => (handlePictureCardPreview(file))
                    }, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_zoom_in)
                        ]),
                        _: 1
                      })
                    ], 8, _hoisted_9),
                    (!_ctx.disabled)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "el-upload-list__item-delete",
                          onClick: ($event: any) => (handleRemove(file))
                        }, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Delete)
                            ]),
                            _: 1
                          })
                        ], 8, _hoisted_10))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["action", "file-list", "disabled"]),
            _createVNode(_component_el_dialog, {
              modelValue: dialogVisible.value,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((dialogVisible).value = $event))
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  width: "100%",
                  src: dialogImageUrl.value,
                  alt: ""
                }, null, 8, _hoisted_11)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "摘要" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(bindData).createOrEditFormData.summary,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(bindData).createOrEditFormData.summary) = $event)),
              readonly: isEdit.value,
              type: "textarea",
              "input-style": [{background:(isEdit.value===true?'#f5f7fa':'')}],
              autosize: { minRows: 2, maxRows: 4 },
              autocomplete: "off"
            }, null, 8, ["modelValue", "readonly", "input-style"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "活动内容" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(bindData).createOrEditFormData.request,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(bindData).createOrEditFormData.request) = $event)),
              readonly: isEdit.value,
              type: "textarea",
              "input-style": [{background:(isEdit.value===true?'#f5f7fa':'')}],
              autosize: { minRows: 4, maxRows: 8 },
              autocomplete: "off"
            }, null, 8, ["modelValue", "readonly", "input-style"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "rules"]),
    _createVNode(_component_el_container, { class: "invest-detail-btn" }, {
      default: _withCtx(() => [
        (isEdit.value && _unref(bindData).createOrEditFormData.status == 1)
          ? (_openBlock(), _createBlock(_unref(ElButton), {
              key: 0,
              type: "primary",
              onClick: handleEdit,
              size: "large"
            }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!isEdit.value && _unref(bindData).createOrEditFormData.status == 1)
          ? (_openBlock(), _createBlock(_unref(ElButton), {
              key: 1,
              type: "danger",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (saveEvent(1,communityFormRef.value))),
              size: "large"
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(bindData).createOrEditFormData.status == 1)
          ? (_openBlock(), _createBlock(_unref(ElButton), {
              key: 2,
              type: "primary",
              onClick: _cache[13] || (_cache[13] = ($event: any) => (saveEvent(2,communityFormRef.value))),
              size: "large"
            }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (
          _unref(bindData).createOrEditFormData.status > 1 &&
          _unref(bindData).createOrEditFormData.status <= 3
        )
          ? (_openBlock(), _createBlock(_unref(ElButton), {
              key: 3,
              type: "primary",
              onClick: _cache[14] || (_cache[14] = ($event: any) => (updateActivityStatusEvent(1))),
              size: "large"
            }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_unref(ElButton), {
          size: "large",
          onClick: toCommunityList
        }, {
          default: _withCtx(() => [
            _hoisted_16
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((dialogVisible).value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          width: "100%",
          src: dialogImageUrl.value,
          alt: ""
        }, null, 8, _hoisted_17)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})